import { newLocation } from '@/core/legacy-auth/gotoV3'
import tabs from '@/core/site-map/map.json'

// URL redirect mappings
// Keys can contain :id or other parameters which will be extracted and replaced
import redirectMap from './redirect.map.json'

const DEFAULT_TAB = 'payments'
const DEFAULT_SUBTAB = 'ProgramList'

const isEmbedded = window.self !== window.top

/**
 * Attempts to match a route path against redirect patterns
 * @param {string} routePath - The current route path
 * @returns {string|null} - The redirect URL or null if no match
 */
function matchRedirectPattern(_routePath) {
  const routePath = decodeURIComponent(_routePath)
  for (const [pattern, redirectTo] of Object.entries(redirectMap)) {
    // Convert pattern to regex, replacing :id with capture group
    const regexPattern = pattern
      .replace(/\//g, '\\/')
      .replace(/:id/g, '(\\d+)')
      .replace(/:(\w+)/g, '([^/]+)')

    const regex = new RegExp(regexPattern)
    const match = routePath.match(regex)

    if (match) {
      // Replace placeholders in redirect URL with captured values
      let redirectUrl = redirectTo
      const paramNames = (pattern.match(/:\w+/g) || []).map(p => p.slice(1))

      paramNames.forEach((paramName, index) => {
        redirectUrl = decodeURIComponent(redirectUrl.replace(`:${paramName}`, match[index + 1].replace('--', '/')))
      })

      // if redirectUrl contains multiple '?' replace all but the first with '&'
      const parts = redirectUrl.split('?')
      if (parts.length > 2) {
        redirectUrl = parts[0] + '?' + parts.slice(1).join('&')
      }

      return redirectUrl
    }
  }

  return null
}

export function routeOldLinks(route, path = '', _isEmbedded) {
  if (typeof _isEmbedded !== 'undefined' ? _isEmbedded : isEmbedded) return
  let [ firstSegment ] = route.path.split('/').filter(Boolean)
  let { page, section } = route.params
  let url
  let tab
  let subTab

  let _path

  page = page || firstSegment

  if (path) {
    _path = path.split('evednetwork/')[1]
  } else {
    const webUrl = window.location.href
    const newUrl = new URL(webUrl)
    newUrl.hash = ''
    // _path = `${newUrl}#${route.fullPath}`
    _path = '#' + decodeURIComponent(`${route.fullPath}`)
  }

  // Check if route matches any redirect pattern
  const redirectMatch = matchRedirectPattern(path || route.fullPath)
  if (redirectMatch) {
    const [redirectPath, queryString] = redirectMatch.split('?')
    let redirectUrl = `/${redirectPath}${queryString ? '?' + queryString : ''}`

    const initialQueryString = route.fullPath.split('?')[1] || ''
    if (!queryString) {
      redirectUrl += `?${initialQueryString}`
    }

    let newUrl = new URL(newLocation.call(this))
    newUrl.hash = redirectUrl
    if (_isEmbedded === false) {
      window.top.location.href = newUrl.href
      return
    }
    window.location.href = newUrl.href
    return
  }

  const hasReturnUrl = this.$router.currentRoute.query.returnUrl || (this.$routerHistory.previous().path && this.$routerHistory.previous().path.indexOf('returnUrl') >= 0)
  // if (document.referrer || hasReturnUrl) return
  if (hasReturnUrl || this.$router.currentRoute.query.sk) return

  switch (page) {
    case 'Programs':
      tab = 'payments'
      break

    default:
      tab = DEFAULT_TAB
  }

  const siteMap = (tabs[page] || {}).pack || {}
  const subTabs = Object.keys(siteMap)

  subTab = subTabs.find(st => (siteMap[st].name || '').toLowerCase() === (section || '').toLowerCase())
  subTab = subTab || DEFAULT_SUBTAB

  const querySrc = path
    ? `path=${_path}`
    : `v2=${encodeURIComponent(_path)}`

  url = `/${tab}/${subTab}?${querySrc}`

  if ((!tab || !subTab) && !_path) {
    return
  }

  let newUrl = new URL(newLocation.call(this))
  newUrl.hash = url

  // window.location.href = newUrl.href
}



// WEBPACK FOOTER //
// ./src/components/LegacyContainer/routeOldLinks.js